import { Controller } from "@hotwired/stimulus"

// Una riga di Catalogo in pages/Piani.js: si inviano solo i campi modificati (mod[p.codice], con le caselle come
// "true"/"false" nel campo nascosto accanto) e «Salva» resta spento finché non si modifica qualcosa.
export default class extends Controller {
  static targets = ["salva"]

  modifica(event) {
    const campo = event.target
    const nome = campo.dataset.nome
    if (!nome) return
    if (campo.type === "checkbox") {
      const nascosto = this.element.querySelector(`input[data-nome-di="${nome}"]`)
      nascosto.name = nome
      nascosto.value = campo.checked ? "true" : "false"
    } else {
      campo.name = nome
    }
    this.salvaTarget.disabled = false
  }
}
